import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'src/redux/store';

interface OrbitAIGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * `OrbitAIGuard` is a guard component that checks if the user has purchased
 * the Orbit AI Add-on, and redirects Enterprise users away from Orbit AI.
 *
 * **Behaviour:**
 * - Redirects Enterprise users to `/dashboard`.
 * - Retrieves user details from the Redux store.
 * - Checks if the `isOrbitAiAddonPurchased` key is true.
 * - Renders the `children` if purchased, otherwise renders the provided custom `fallback` component (or `null`).
 */
export default function OrbitAIGuard({ children, fallback }: OrbitAIGuardProps) {
  const isEnterprisePlan = useSelector(
    (state: RootState) =>
      state.user?.isEnterprisePlan ||
      state.user?.activePlan === state.user?.planDetails?.enterprise
  );
  const userDetails = useSelector(
    (state: RootState) => state.counter.userDetails
  ) as any;

  if (isEnterprisePlan) {
    return <Navigate to="/dashboard" replace />;
  }

  const isOrbitAiAddonPurchased = userDetails?.isOrbitAiAddonPurchased;

  if (isOrbitAiAddonPurchased) {
    return <>{children}</>;
  }

  return <>{fallback || null}</>;
}
